import { Directive, Input, HostListener, Optional, ElementRef } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[uiMoeda]',
})
export class UiMoedaDirective {

  @Input('uiMoeda') valor: string;

  constructor( @Optional() private model: NgModel,
    private evento: ElementRef) { }

  @HostListener('keyup', ['$event'])
  keyup(evento) {
    try {
      if (this.model !== null) {
        const valor = this.format(this.model.value);
        this.model.viewToModelUpdate(valor);
        this.model.valueAccessor.writeValue(valor);
      } else {
        this.evento.nativeElement.value = this.format(this.evento.nativeElement.value);
      }
    } catch (e) {

    }
  }

  public format(value, attributes?) {
    if (value) {
      value = value.replace(/^\s+|\s+$/g, '');

      if (value !== '') {
        let sign = '';

        if (attributes !== undefined && attributes.uiMoeda === 'acceptNegativeValue' && (value.substring(0, 1) ===
          '-' || value.substring(value.length - 1, value.length) === '-')) {
          sign = '-';
        }
        value = value.replace(/[^0-9]+/g, '');

        if (value.length > 0) {
          value = parseInt(value, 10);

          if (value === 0) {
            return sign + '0.00';
          } else if (value < 10) {
            return sign + '0.0' + value;
          } else if (value >= 10 && value < 100) {
            return sign + '0.' + value;
          } else {
            value = value.toString();
            return sign + value.substring(0, value.length - 2) + '.' + value.substring(value.length - 2, value.length);
          }
        }
        return sign + '0.00';
      }
    }
    return '0.00';
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/diretives/ui-moeda.directive.ts